import { DatasetDataInfo } from "models/dataset-models";
import { InstantDoubleValue } from "../api/model/dataset/InstantDoubleValue";

export const formatDatasetValue = (dataset:DatasetDataInfo, data: InstantDoubleValue | null | undefined) =>
    data ? data.value.toFixed(dataset?.decimalPlaces ?? 2) : "N/A";
